import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Typography, Pagination, FormControl, Select, MenuItem, Card, CardContent, Button, Box } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import api from "../../api";
const CardList = ({ token }) => {
    const { deckId } = useParams();
    const [cards, setCards] = useState([]);
    const [deck, setDeck] = useState(null);
    const [page, setPage] = useState(1);
    const [cardsPerPage, setCardsPerPage] = useState(20);
    const navigate = useNavigate();

    const decoded = jwtDecode(token);
    const userId = decoded.user._id;

    useEffect(() => {
        api.get(`/decks/${deckId}`)
        .then((response) => {
            setDeck(response.data.deck || null);
        })
        .catch((error) => {
            console.error("Error fetching deck:", error);
        });

        api.get(`/decks/${deckId}/cards`)
            .then((response) => {
                console.log(JSON.stringify(response.data.cards, null, 2));
                setCards(response.data.cards || []);
            })
            .catch((error) => {
                console.error("Error fetching cards:", error);
                setCards([]);
            });
    }, [token, deckId]);

    const handlePageChange = (event, value) => setPage(value);
    const handleCardsPerPageChange = (event) => {
        setCardsPerPage(event.target.value);
        setPage(1); // Reset to first page
    };

    const startIndex = (page - 1) * cardsPerPage;
    const paginatedCards = Array.isArray(cards) ? cards.slice(startIndex, startIndex + cardsPerPage) : [];

    return (
        <Container sx={{ textAlign: "center", maxWidth: "70%", margin: "auto" }}>
            <Typography variant="h4" gutterBottom>
                Cards in Deck
            </Typography>

            {deck && deck.createdBy === userId && (
                <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                    <Button variant="contained" color="primary" onClick={() => navigate(`/decks/${deckId}/add-card`)}>
                        Add Card
                    </Button>
                </Box>
            )}

            <FormControl sx={{ minWidth: 120, mb: 2 }}>
                <Select value={cardsPerPage} onChange={handleCardsPerPageChange}>
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                </Select>
            </FormControl>

            {Array.isArray(paginatedCards) && paginatedCards.length > 0 ? (
                paginatedCards.map((card, index) => (
                    <Card key={card._id} sx={{ mb: 2, boxShadow: 3 }}>
                        <CardContent>
                            <Typography variant="h6">
                                {startIndex + index + 1}. {card.question}
                            </Typography>
                            <Typography variant="body1" color="textSecondary">
                                {card.answer}
                            </Typography>
                        </CardContent>
                    </Card>
                ))
            ) : (
                <Typography variant="h6" color="textSecondary">
                    No cards found.
                </Typography>
            )}

            <Pagination
                count={Math.ceil(cards.length / cardsPerPage)}
                page={page}
                onChange={handlePageChange}
                sx={{ mt: 2 }}
            />
        </Container>
    );
};

export default CardList;
